import { FieldComponent } from 'src/app/common/components/field/field.component';
import { Observable } from 'rxjs';
import { FormControl } from '@angular/forms';
import {
  AfterViewInit,
  Component,
  Input,
  ViewChild,
  OnDestroy,
} from '@angular/core';
import { GoogleMapService } from 'src/app/modules/shared/services/google.map.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'ig-location-input',
  templateUrl: './location.input.component.html',
  styleUrls: ['./location.input.component.scss'],
})
export class LocationInputComponent implements AfterViewInit, OnDestroy {
  googleLoaded$: Observable<boolean>;
  private valueChangesSubscription: Subscription;

  @Input() label: string = 'Location / Address * (or check Virtual Events)';
  @Input() hint: string =
    'Start typing the physical address and select from a verified Google Maps address below';
  @Input() control: FormControl;
  @Input() cls: string = '';
  @Input() isReadOnly: boolean = false;
  @Input() types: string[] = [];

  @ViewChild('inputElement', { static: true }) inputElement: FieldComponent;

  constructor(public googleMapService: GoogleMapService) {
    try {
      this.googleLoaded$ = this.googleMapService.loadGoogleMapApi();
    } catch (e) {
      console.error(e);
    }
  }

  ngAfterViewInit() {
    this.setInitialDisplayValue();
    this.valueChangesSubscription = this.control.valueChanges.subscribe((value) => {
      this.updateDisplayValue(value);
    });

    try {
      this.googleLoaded$.subscribe((isLoaded: boolean) => {
        if (!isLoaded) return;

        const autoComplete = new google.maps.places.Autocomplete(
          this.inputElement.input.nativeElement,
          {
            fields: ['address_components', 'geometry', 'formatted_address', 'name', 'place_id'],
            types: this.types,
            componentRestrictions: { country: ['us'] },
          }
        );

        this.inputElement.input.nativeElement.addEventListener('click', function () {
          this.blur();
          this.focus();
        });
        autoComplete.addListener('place_changed', () => {
          const place = autoComplete.getPlace();

          if (place.geometry) {
            let stateAbbr = '',
              cityName = '',
              country = '';
            if (place.address_components) {
              place.address_components.forEach((x) => {
                if (x.types.includes('administrative_area_level_1')) {
                  stateAbbr = x.short_name;
                }
                if (x.types.includes('locality')) {
                  cityName = x.long_name;
                }
                if (x.types.includes('country')) {
                  country = x.long_name;
                }
              });
            }
            this.control.setValue({
              lat: place.geometry.location.lat(),
              lng: place.geometry.location.lng(),
              address: place.formatted_address,
              address_components: place.address_components,
              placeId: place.place_id,
              cityName,
              stateAbbr,
              country,
            });
            this.inputElement.input.nativeElement.value = place.formatted_address;
          } else {
            this.control.setValue({
              address: place.name,
            });
            this.inputElement.input.nativeElement.value = place.name;
          }
        });
      });
    } catch (e) {
      console.error(e);
    }
  }

  clear() {
    this.control.setValue(null);
    this.inputElement.input.nativeElement.value = '';
  }

  private setInitialDisplayValue() {
    const currentValue = this.control.value;
    this.updateDisplayValue(currentValue);
  }

  private updateDisplayValue(value: any) {
    if (value) {
      let displayValue = '';

      if (typeof value === 'object' && value.address) {
        displayValue = value.address;
      } else if (typeof value === 'string') {
        displayValue = value;
      }

      if (displayValue && this.inputElement?.input?.nativeElement) {
        this.inputElement.input.nativeElement.value = displayValue;
      }
    } else {
      if (this.inputElement?.input?.nativeElement) {
        this.inputElement.input.nativeElement.value = '';
      }
    }
  }

  ngOnDestroy() {
    if (this.valueChangesSubscription) {
      this.valueChangesSubscription.unsubscribe();
    }
  }
}
